import EntityIcon from 'Components/Atoms/EntityIcon/EntityIcon';
import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import RowItem from 'Components/Atoms/Row/RowItem';
import RowItemInfo from 'Components/Atoms/Row/RowItemInfo';
import RowItemTitle from 'Components/Atoms/Row/RowItemTitle';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { getInternalDatasetIdByName } from 'Services/helpers';
import { RelationService } from 'Services/Relation/Application/RelationService';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { saveBusinessUnitEntity } from 'Store/BusinessUnit/Actions';
import { getBusinessUnitById, getBusinessUnitDatasetKeys, isBusinessUnitDatasetFetching } from 'Store/BusinessUnit/Selectors';
import { saveCandidateEntity } from 'Store/Candidate/Actions';
import { getCandidateById, getCandidateDatasetKeys, isCandidateDatasetFetching } from 'Store/Candidate/Selectors';
import { updateContact } from 'Store/Contact/Actions';
import { getContactById, getContactDatasetKeys, isContactDatasetFetching } from 'Store/Contact/Selectors';
import { fetchAllDatasets, saveRelation } from 'Store/FieldManagement/Actions';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { getEntitiesById } from 'Store/Settings/Entities/Selectors';
import { saveVacancyEntity } from 'Store/Vacancy/Actions';
import { getVacancyById, getVacancyDatasetKeys, isVacancyDatasetFetching } from 'Store/Vacancy/Selectors';
import styles from './EntityRelationOverview.module.sass';

const EntityRelationOverview = ({
    entitySetting, record_id,

    handleValidation,

    entityById,

    vacancy, candidate, contact, business_unit,
    vacancyDatasetKeys, candidateDatasetKeys, contactDatasetKeys, businessUnitDatasetKeys,
    isVacancyDatasetFetching, isCandidateDatasetFetching, isContactDatasetFetching, isBusinessUnitFetching,

    ...props
}: EntityRelationStepProps) => {
    const [state, setState] = useState({
        isEdit: false,
        isRelationFetching: false,
        isPreviewLoading: true,
        isActive: false
    });

    const initialData = useMemo(() => ({
        ...vacancy?.relations,
        ...candidate?.relations,
        ...contact?.relations,
        ...business_unit?.relations
    }), [vacancy?.relations, candidate?.relation, contact?.relations, business_unit?.relations]);
    const [data, setData] = useState(initialData);

    const checkValidation = (values?: any) => {
        handleValidation(relationEditables.every(i => (values || data)?.[i.id]?.length > 0))
    };
    
    const relationPreviews = useMemo(() => (entitySetting.relations || [])
        .filter(i => i.isActive && !i.isEditable)
        .sort((a, b) => a.order - b.order)
    , [entitySetting.relations]);

    const relationEditables = useMemo(() => (entitySetting.relations || [])
        .filter(i => i.isActive && i.isEditable)
        .sort((a, b) => a.order - b.order)
    , [entitySetting.relations]);

    return <>
        {
            relationEditables.length > 0 && relationEditables.map((i, idx) => {
                return <FormGroup title={EntityHelper.getDisplayValueByName(entityById?.[i.id]?.name)}>
                    <Field
                        isEdit={false}
                        type={FieldType.Multi_Selector}
                        value={data?.[i.id] || []}
                        fieldProperties={{
                            alignLeft: true,
                            dataset: [getInternalDatasetIdByName(entityById?.[i.id]?.name)]
                        }}
                    />
                </FormGroup>;
            })
        }
    </>;
}

interface Props {
    entitySetting: any
    record_id: string
    handleValidation?: any
};

const mapState = (state: StoreState, props: Props) => ({
    entityById: getEntitiesById(state),

    vacancy: getVacancyById(state, props.record_id),
    candidate: getCandidateById(state, props.record_id),
    business_unit: getBusinessUnitById(state, props.record_id),
    contact: getContactById(state, props.record_id),

    vacancyDatasetKeys: getVacancyDatasetKeys(state) || [],
    candidateDatasetKeys: getCandidateDatasetKeys(state) || [],
    contactDatasetKeys: getContactDatasetKeys(state) || [],
    businessUnitDatasetKeys: getBusinessUnitDatasetKeys(state) || [],

    isVacancyDatasetFetching: isVacancyDatasetFetching(state),
    isCandidateDatasetFetching: isCandidateDatasetFetching(state),
    isContactDatasetFetching: isContactDatasetFetching(state),
    isBusinessUnitFetching: isBusinessUnitDatasetFetching(state)
});

const mapDispatch = {
    saveVacancyEntity,
    updateContact,
    saveCandidateEntity,
    saveBusinessUnitEntity,
    saveRelation,
    fetchAllDatasets
};

type EntityRelationStepProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntityRelationOverview);